import Vue from 'vue';
import gaService from './ga.service';

export default {
  async openSession(gameId) {
    gaService.send('games', 'betconstruct', gameId);
    return (await Vue.http.get(`/api/betconstruct/session/open/${gameId}`)).data;
  },
  async openDemoSession(gameId) {
    gaService.send('games', 'betconstruct', gameId);
    return (await Vue.http.get(`/api/betconstruct/session/opendemo/${gameId}`)).data;
  }
}



// WEBPACK FOOTER //
// ./_common/services/betconstruct.service.js